import React from 'react'

const Error = ({ message }) => (
  <div className="d-flex justify-content-center align-self-center align-content-center pt-5 pb-5">
    {message}
  </div>
)

export default Error
